import React from 'react';
import { Prospect, Proposal, ProposalItem, SectionConfig } from '../shared/types';
import { HeroSection } from './sections/HeroSection';
import { DiagnosisSection } from './sections/DiagnosisSection';
import { ROICalculatorSection } from './sections/ROICalculatorSection';
import { PricingSection } from './sections/PricingSection';
import { CTASection } from './sections/CTASection';
import { FooterSection } from './sections/FooterSection';
import { EcosystemSection } from './sections/EcosystemSection';
import { GoogleChannelSection } from './sections/GoogleChannelSection';
import { TimelineSection } from './sections/TimelineSection';
import { AppTeaserSection } from './sections/AppTeaserSection';
import { PortalTeaserSection } from './sections/PortalTeaserSection';
import { CrmTeaserSection } from './sections/CrmTeaserSection';

interface SectionRendererProps {
  prospect: Prospect;
  proposal: Proposal;
  items: ProposalItem[];
  sections: SectionConfig[];
}

export const SectionRenderer: React.FC<SectionRendererProps> = ({
  prospect,
  proposal,
  items,
  sections,
}) => {
  // Sort sections by sort_order
  const sortedSections = [...sections].sort((a, b) => a.sort_order - b.sort_order);

  return (
    <main className="min-h-screen bg-white text-slate-900 flex flex-col justify-between selection:bg-[var(--ym-prospect-primary)] selection:text-white">
      <div>
        {sortedSections.map((section) => {
          if (!section.is_visible) return null;

          const stype = section.section_type || section.type;
          switch (stype) {
            case 'hero':
              return <HeroSection key={section.id} prospect={prospect} config={section.config} />;
            case 'diagnosis':
              return <DiagnosisSection key={section.id} prospect={prospect} />;
            case 'ecosystem':
              return <EcosystemSection key={section.id} prospect={prospect} />;
            case 'app_teaser':
              return <AppTeaserSection key={section.id} prospect={prospect} />;
            case 'portal_teaser':
              return <PortalTeaserSection key={section.id} prospect={prospect} />;
            case 'crm_teaser':
              return <CrmTeaserSection key={section.id} />;
            case 'google_channel':
              return <GoogleChannelSection key={section.id} prospect={prospect} />;
            case 'timeline':
              return <TimelineSection key={section.id} prospect={prospect} />;
            case 'roi_calculator':
              return (
                <ROICalculatorSection
                  key={section.id}
                  prospect={prospect}
                  proposal={proposal}
                />
              );
            case 'pricing':
            case 'plans':
              return (
                <PricingSection
                  key={section.id}
                  prospect={prospect}
                  items={items}
                />
              );
            case 'cta':
              return <CTASection key={section.id} prospect={prospect} />;
            default:
              return null;
          }
        })}
      </div>

      <FooterSection prospect={prospect} />
    </main>
  );
};
